export default "__VITE_ASSET__CuW8gAGx__"